export const defaultList = {
    totalCount: 0,
    entities: [],
};

export const sizePerPageList = [
    {text: "10", value: 10},
    {text: "50", value: 50},
    {text: "100", value: 100},
];

export const defaultUser = {
    id: "",
    name: "",
    phone: "",
    password: "",
    active: true,
    role: "",
};

export const defaultOrg = {
    name: "",
    phone: "",
    active: true,
    address: "",
    city: "",
    pinCode: "",
    adminUserName: "",
    adminPassword: "",
};

export const defaultOtherSetting = {
    id: "",
    settingType: "",
    settingValue: "",
};

export const defaultPassword = {
    password: "",
    confirmPassword: "",
};

export const defaultRole = {
    id: "",
    name: "",
    description: "",
    allowedPermissions: [],
};

export const defaultVehicle = {
    id: "",
    vehicleNumber: "",
    emptyWeight: "",
    modelMake: "",
};

export const defaultExpenseCategory = {
    id: "",
    name: "",
    description: "",
    color: "#3699FF", // Default color
    icon: "",
};

export const defaultExpense = {
    id: "",
    title: "",
    amount: 0,
    date: new Date(),
    category: "",
    description: "",
    bankAccountId: ""
};

export const defaultClientExpense = {
    id: "",
    totalAmount: "",
    expenseDate: new Date().toISOString(),
    category: null,
    ledgerAccount: null,
    narration: "",
    referenceNumber: "",
};

export const defaultCustomerSale = {
    id: "",
    ticketSequenceNumber: "",
    vehicle: null,
    vehicleId: "",
    vehicleNumber: "",
    saleItemName: "",
    vehicleEmptyWeight: "",
    vehicleLoadedWeight: "",
    photoIds: [],
};

export const defaultRawCustomerSale = {
    id: "",
    ticketSequenceNumber: "",
    salesCustomer: null,
    itemsList: [],
    paymentsList: [],
    vehicle: null,
    vehicleNumber: "",
    emptyWeight: null,
    loadedWeight: null,
    loadedWeightCorrection: 0,
    emptyVehiclePhoto: "",
    loadedVehiclePhoto: "",
    salesFirstStepDate: new Date(),
    salesSecondStepDate: null,
    destination: "",
    leadKm: null,
    driverName: "",
    salesPersonId: "",
    customerPhoneNumber: "",
    remarks: "",
    roundOffAmount: 0,
    isPartialRecord: false,
    saleType: "ONE_STEP",
    createInvoice: false,
    generateEwayBill: false,
    generateEinvoice: false,
    shipToAddressId: "",
};

export const defaultRawPurchase = {
    id: "",
    purchaseTicketNumber: "",
    supplier: null,
    itemsList: [],
    vehicle: null,
    vehicleNumber: "",
    emptyWeight: null,
    loadedWeight: null,
    loadedWeightCorrection: 0,
    purchaseDate: new Date(),
    driverName: "",
    battaAmount: 0,
    inspectionNotes: "",
    remarks: "",
    roundOffAmount: 0,
    purchasePersonId: "",
    dumpLocation: "QUARRY_TO_CRUSHER",
    isPartialRecord: false,
    purchaseType: "ONE_STEP",
    purchaseFirstStepDate: null,
    purchaseSecondStepDate: null,
};

export const defaultSaleItem = {
    id: "",
    quantity: null,
    discountAmount: 0,
};

export const defaultSalePayment = {
    referenceNumber: "",
    narration: "",
    totalAmount: 0,
    categoryId: "",
    ledgerAccountId: "",
};

export const defaultSalesCustomer = {
    id: "",
    name: "",
    billingName: "",
    phone: "",
    address: "",
    pinCode: "",
    gstNumber: "",
    panNumber: "",
    creditLimit: 0,
    openingBalance: 0,
    shippingAddresses: [],
};

export const defaultSupplier = {
    id: "",
    name: "",
    billingName: "",
    phone: "",
    address: "",
    pinCode: "",
    gstNumber: "",
    panNumber: "",
    creditLimit: 0,
    openingBalance: 0,
};

